import React, { forwardRef, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { getFullNameUser, numberWithCommas } from "../../Helpers/Utils/Common";
import moment from "moment";

const PrintHourly = forwardRef((props, ref) => {
  return (
    <div ref={ref} className="p-2">
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          {window.company_name}
        </label>
      </div>
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          {window.company_address}
        </label>
      </div>
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          {" "}
          {window.company_vat_reg_tin}
        </label>
      </div>
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          {window.company_min}
        </label>
      </div>
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          {window.company_sn}
        </label>
      </div>
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          {window.company_ptu_no}
        </label>
      </div>
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          {window.issued_date}
        </label>
      </div>
      <div className="d-flex row justify-content-center">
        <label className="d-flex row justify-content-center print-text-sales">
          Date: {moment().format("MMMM DD, YYYY")}
        </label>
      </div>
      <table className="table table-bordered left ms-5 ">
        <tbody>
          <tr>
            <th colSpan={2}>
              HOURLY SALES REPORT{" "}
              {props.restoType && props.restoType !== ""
                ? ` (${props.restoType.toUpperCase()})`
                : ""}
            </th>
          </tr>
          <tr>
            <th>TIME</th>
            <th>TOTAL SALES</th>
          </tr>
          {props.data &&
            props.data.map((item, index) => (
              <tr key={index}>
                <td>{item.HourRange}</td>
                <td className="text-end">
                  {numberWithCommas(item.total_amount)}
                </td>
              </tr>
            ))}
            <tr>
                <th>GRAND TOTAL</th>
                <th className="d-flex justify-content-end">{numberWithCommas(
                props.data && props.data.length > 0
                  ? props.data
                      .map((item) => parseFloat(item.total_amount))
                      .reduce((a, b) => a + b, 0)
                      .toFixed(2)
                  : "0.00"
              )}</th>
            </tr>
        </tbody>
      </table>
      {/* {props.data && props.data.map((item) => (
            <Row className='ms-2'>
                <Col>{item.HourRange}</Col>
                <Col className='d-flex justify-content-end'>{numberWithCommas(item.total_amount)}</Col>
            </Row>
        ))} */}
      {/* <Row>
        <hr />
        <Col className="d-flex justify-content-end">
          <h5>
            <strong>
              Total Sales :{" "}
              {numberWithCommas(
                props.data && props.data.length > 0
                  ? props.data
                      .map((item) => parseFloat(item.total_amount))
                      .reduce((a, b) => a + b, 0)
                      .toFixed(2)
                  : "0.00"
              )}
            </strong>
          </h5>
        </Col>
      </Row> */}
    </div>
  );
});

export default PrintHourly;
